import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  IconButton,
} from "@mui/material";

interface CommentDialogProps {
  open: boolean;
  onClose: () => void;
  payload: any;
}

const CommentDialog: React.FC<CommentDialogProps> = ({
  open,
  onClose,
  payload,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Summary</span>
        <IconButton onClick={onClose} size="small">
          <Button onClick={onClose}>Close</Button>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <pre className="whitespace-pre-wrap break-words p-4 bg-gray-100 rounded">
          {JSON.stringify(payload, null, 2)}
        </pre>
      </DialogContent>
    </Dialog>
  );
};

export default CommentDialog;
